import {
  PRODUCT_INVITATION_CARD,
  PRODUCT_JUKE,
  PRODUCT_MICRO_WEBSITE,
  PRODUCT_THEME_TEMPLATE,
  PRODUCT_WECHAT_WEAPP
} from '@constant'
import { isNormal } from '@merchant-backend/util'

/**
 * 产品对应的宣传页面
 * @param {产品ID} id
 */
export const getProductIntroPath = id => {
  const paths = {
    [PRODUCT_MICRO_WEBSITE]: '/localMerchant/weiShopSetting/intro',
    [PRODUCT_THEME_TEMPLATE]: '/localMerchant/themeChose/intro',
    [PRODUCT_WECHAT_WEAPP]: '/localMerchant/liteApp/intro',
    [PRODUCT_INVITATION_CARD]: isNormal()
      ? '/localMerchant/marketingCenter/DeliverModule/intro'
      : '/localMerchant/marketingCenter/DeliverModule',
    [PRODUCT_JUKE]: '/localMerchant/jukeTreasure/intro',
    juke: '/localMerchant/jukeTreasure/intro' // 兼容老的字符串
  }

  return paths[String(id)]
}
